<template>
    <div>
        <el-dialog
        :title="$t('orderDetail.IncomeStatement')"
        :visible.sync="dialogVisible"
        width="1180px"
        :before-close="detailHandleClose"
        :footer="null">
            <el-table :data="detailTableData" >
                <el-table-column prop="productName" :label="$t('orderDetail.Product')" width="290">
                    <template slot-scope="scope">
                        <div class="f">
                            <div style="margin-right: 10px">
                                <el-popover placement="right" width="280" trigger="hover">
                                    <el-image fit="cover" :src="scope.row.sizeImagePath"></el-image>
                                    <el-image style="width: 70px;height: 70px" :src="scope.row.sizeImagePath" slot="reference"></el-image>
                                </el-popover>
                            </div>
                            <div>
                                <el-tooltip effect="dark" :content="scope.row.productName" placement="top">
                                    <div class="ellipsis2" style="width: 180px">{{scope.row.productName}}</div>
                                </el-tooltip>
                                <div>{{ scope.row.options_render_str }}</div>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="skuCode" label="SKU" width="190"></el-table-column>
                <el-table-column prop="purchasePrices" :label="$t('orderDetail.PurchasePrices')" width="146">
                    <template slot-scope="scope">
                        USD{{ scope.row.purchasePrices | numberKeepTwoDecimal }}
                    </template>
                </el-table-column>
                <el-table-column prop="price" :label="$t('orderDetail.prices')" width="146">
                    <template slot-scope="scope">
                        USD{{ scope.row.price | numberKeepTwoDecimal }}
                    </template>
                </el-table-column>
                <el-table-column prop="productNum" :label="$t('orderDetail.Quantity')" width="120"></el-table-column>
                <el-table-column prop="subtotal" :label="$t('orderDetail.Subtotal')" width="120">
                    <template slot-scope="scope">
                        USD{{ scope.row.subtotal | numberKeepTwoDecimal }}
                    </template>
                </el-table-column>
                <el-table-column prop="profit" :label="$t('orderDetail.Profit')" width="120">
                    <template slot-scope="scope">
                        USD{{ scope.row.profit | numberKeepTwoDecimal }}
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
    </div>
</template>

<script>
export default {
  props: {
    detailTableData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dialogVisible: false
    }
  },
  methods: {
    detailHandleClose() {
      this.dialogVisible = false
    },
    show() {
      this.dialogVisible = true
    }
  }
}
</script>
